import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import HyruleField from './components/HyruleField.vue'
import ShadowTemple from './components/ShadowTemple.vue'
import ForestTemple from './components/ForestTemple.vue'
import WaterTemple from './components/WaterTemple.vue'
import SpiritTemple from './components/SpiritTemple.vue'
import FireTemple from './components/FireTemple.vue'

Vue.config.productionTip = false;
Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'hash',
  base: __dirname,
  routes: [
    { path: '/', component: HyruleField },
    { path: '/shadow', component: ShadowTemple },
    { path: '/forest', component: ForestTemple },
    { path: '/water', component: WaterTemple },
    { path: '/spirit', component: SpiritTemple },
    { path: '/fire', component: FireTemple }
  ]
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');